export default "__VITE_ASSET___5ZgP5dP__"